import histroy from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { addLocationMutation } from '../../../lib/graphql';

export const updateLocation = (LocationName, coordinates, id, description, isActive) => {

  return async (dispatch, getState, { client }) => {

    try {
      dispatch(setLoaderStart('updateLocation'));
      if (!coordinates || coordinates == '' || coordinates == 'null') {
        showToaster({ messageId: 'selectLoc', toasterType: 'error' });
        return  dispatch(setLoaderComplete('updateLocation'));
      }
      isActive = Number(isActive);
  
      const { data } = await client.mutate({
        mutation: addLocationMutation,
        variables: {
          LocationName,
          coordinates,
          id,
          description,
          isActive
        },
      });
  
      dispatch(setLoaderComplete('updateLocation'));
  
      if (data?.addLocation?.status === 200) {
        showToaster({ messageId: 'updateLoc', toasterType: 'success' });
        histroy.push('/siteadmin/location');
      } else if (data?.addLocation?.status !== 200) {
        showToaster({ messageId: 'errorMessage', requestContent: { content: data?.addLocation?.errorMessage }, toasterType: 'error' });
      }
    } catch (error) {
      showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
      dispatch(setLoaderComplete('updateLocation'));
    }
  }
}